import React from 'react';
import { formatDuration } from 'features/agents/lib/format';

/** Four compact tiles for the last 7 days; the same card as the Reports tiles. */
export default function RunStats({ stats }) {
  const s = stats || {};
  const tiles = [
    { key: 'total', label: 'Runs', value: s.total ?? 0 },
    { key: 'succeeded', label: 'Succeeded', value: s.succeeded ?? 0 },
    { key: 'failed', label: 'Failed', value: s.failed ?? 0, danger: (s.failed || 0) > 0 },
    { key: 'median', label: 'Median duration', value: formatDuration(s.median_duration_ms) },
  ];
  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-4" aria-label="Last 7 days">
      {tiles.map((t) => (
        <div key={t.key} data-testid={`stat-${t.key}`} className="rounded-lg border border-[color:var(--border-default)] bg-[color:var(--surface-base)] px-3 py-2">
          <div className="text-[11px] text-[color:var(--text-muted)]">{t.label} <span className="text-[color:var(--text-disabled)]">· 7d</span></div>
          <div className={`mt-0.5 text-[18px] font-semibold tabular-nums ${t.danger ? 'text-danger' : 'text-[color:var(--text-primary)]'}`}>
            {typeof t.value === 'number' ? t.value.toLocaleString() : t.value}
          </div>
        </div>
      ))}
    </div>
  );
}
